module.exports = "<div class=\"tab\">\n  <h4 class=\"sep-top\">lorem ipsum (h4) - sep-top</h4>\n  <h4 class=\"sep-bottom\">lorem ipsum (h4) - sep-bottom</h4>\n  <h4 class=\"sep-top sep-bottom\">lorem ipsum (h4) - sep-top sep-bottom</h4>\n\n  <h4 class=\"sep-left\">lorem ipsum (h4) - sep-left</h4>\n  <h4 class=\"sep-right\">lorem ipsum (h4) - sep-right</h4>\n  <h4 class=\"sep-left sep-right\">lorem ipsum (h4) - sep-left sep-right</h4>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/guideline/templates/styling_titles_sep.html
// module id = 88
// module chunks = 0